import { Component, forwardRef, Inject, Input, OnDestroy, OnInit } from '@angular/core'
import { ConfiguratorOptiongroupComponent } from '../configurator-optiongroup/configurator-optiongroup.component'

@Component({
    selector: 'mg-configurator-optiongroup-option',
    templateUrl: './configurator-optiongroup-option.component.html',
    styleUrls: ['./configurator-optiongroup-option.component.scss'],
})
export class ConfiguratorOptiongroupOptionComponent implements OnInit, OnDestroy {
    @Input()
    value: any
    @Input()
    label: string = ''
    @Input()
    description: string
    @Input()
    amount: string
    @Input()
    isAvailable: boolean = true

    constructor(
        @Inject(forwardRef(() => ConfiguratorOptiongroupComponent))
        public _parent: ConfiguratorOptiongroupComponent
    ) {}

    ngOnInit() {
        this._parent.registerOption(this)
    }

    ngOnDestroy(): void {
        this._parent.unregisterOption(this)
    }
}
